module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/tutorial2@2x_448734.jpg";